import * as React from "react";

export default () => {
  return (
    <div>
      Inställningar för debitering av IMD för den nya aviseringsinställningen.
    </div>
  );
};
